import { css } from 'styled-components'

export const imageStyle = css`
	position: relative;
	width: 100%;
	height: 100%;
	overflow-y: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.fallback {
		position: absolute;
		top: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		color: ${({ theme }) => theme.palette.common.white};
		background-color: ${({ theme }) => theme.palette.primary.light};
		border-radius: 50%;
	}
`
